import { workspaceQueryKeys as e } from "./useWorkspaceQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { authApi as n } from "@maat/api-main";
//#region src/workspaces/useMemberPermissionsQuery.ts
var r = (r) => t({
	queryKey: e.memberPermissions(r ?? ""),
	queryFn: () => n.getUserPermissions(r),
	enabled: !!r
});
//#endregion
export { r as useMemberPermissionsQuery };
